import axios from "axios";

const handleError = (error) => {
    throw error?.response?.data;
};

export const apiGet = async (url, config) => {
    try {
        const response = await axios.get(url, config);
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

export const apiPost = async (url, data, config) => {
    try {
        const response = await axios.post(url, data, config);
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

export const apiPatch = async (url, data, config) => {
    try {
        const response = await axios.patch(url, data, config);
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

export const apiPut = async (url, data, config) => {
    try {
        const response = await axios.put(url, data, config);
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

export const apiDelete = async (url, config) => {
    try {
        const response = await axios.delete(url, config);
        return response.data;
    } catch (error) {
        handleError(error);
    }
};
